import styled from "styled-components";

export const Wrap = styled.div`
  display: flex;
  /* align-items: center; */
  flex-direction: column;
`;
Wrap.Text = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
Wrap.Title = styled.h1`
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  text-align: center;
  color: #0d263b;
`;

Wrap.Descript = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #696969;
`;
Wrap.Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 50px 225px;
`;
